import React from 'react';
import { useIntl } from 'react-intl';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { OwnerBillingInformationIcons } from '../../../../components/Common/Assets/SvgIconComponent/SideMenuIcons';
import messages from '../../../../locale/jsonMessages';

const OwnerBillingInformation = ({
    deliveryPrice, convertCurrency, discount, total,
    discountType, serviceFee, payoutToHost, payoutCurrency,
    pricingData, serviceFeeType, serviceFeeValue, securityDeposit, claimPayout,
    promoCode, promoCodeType, promoDiscount
}) => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.ownerBillingInformation)} icon={<OwnerBillingInformationIcons />}>
                <ViewTableBodyInformation
                    title={formatMessage(messages.rentalPrice)}
                    pricingData={pricingData}
                />
                {deliveryPrice > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.deliveryFeeLabel)}
                    currencyData
                    amount={deliveryPrice}
                    convertCurrency={convertCurrency}
                />}
                {discount > 0 && <ViewTableBodyInformation
                    title={discountType}
                    currencyData
                    amount={discount}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {promoDiscount > 0 && promoCodeType === 'host' && <ViewTableBodyInformation
                    title={promoCode}
                    currencyData
                    amount={promoDiscount}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {serviceFee > 0 && <ViewTableBodyInformation
                    title={`${formatMessage(messages.serviceFee)} ${(serviceFeeType != 'fixed' && Number(serviceFeeValue) > 0) ? '(' + serviceFeeValue?.toFixed(2) + '%)' : ''} `}
                    currencyData
                    amount={serviceFee}
                    convertCurrency={convertCurrency}
                    isMinus
                />}
                {securityDeposit > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.securityDeposit)}
                    currencyData
                    amount={securityDeposit}
                    convertCurrency={convertCurrency}
                />}
                {total > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.total)}
                    currencyData
                    amount={total}
                    convertCurrency={convertCurrency}
                    isBold
                />}
                {payoutToHost > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.ownerEarnings)}
                    currencyData
                    amount={payoutToHost}
                    convertCurrency={payoutCurrency}
                    isBold
                />}
                {claimPayout > 0 && <ViewTableBodyInformation
                    title={formatMessage(messages.securityDepositToHost)}
                    currencyData
                    amount={claimPayout}
                    convertCurrency={convertCurrency}
                    isBold
                />}
            </ViewTableInformation>
        </div>
    )
}

export default OwnerBillingInformation;

